import React, { useEffect } from 'react';
import { compose } from "redux";
import { connect } from "react-redux";
import {
    getSalesTh,
    checkStatusTh,
    applySalesFiltersTh,
    resetSalesFiltersTh,
    refreshStatusTh,
    refreshPendingTh,
} from "../../redux/salesReducer";
import Sales from "./Sales";

let mapStateToProps = (state) => ({
    // Diqqət et: state.salesPage.products yoxsa state.salesPage.sales? Redux-da adın nədirsə onu yaz.
    salesList: state.salesPage.products,
    totalPages: state.salesPage.totalPages,
    totalElements: state.salesPage.totalElements,
    size: state.salesPage.size,
    filters: state.salesPage.filters,
});

const SalesContainer = ({ getSalesTh, salesList, filters, ...props }) => {
    useEffect(() => {
        // Səhifə yüklənəndə datanı 1 dəfə çağırırıq
        getSalesTh(0, 10, filters);
    }, []);

    return (
        <div className="content-wrapper">
            {/* salesList gəlib çatanda və içi boş olmayanda komponenti göstəririk */}
            {salesList && salesList.length > 0 ? (
                <Sales salesList={salesList} getSalesTh={getSalesTh} filters={filters} {...props} />
            ) : (
                <div className="p-3 text-center">Məlumat yüklənir və ya tapılmadı...</div>
            )}
        </div>
    );
};

export default compose(
    connect(mapStateToProps, {
        getSalesTh,
        checkStatusTh,
        applySalesFiltersTh,
        resetSalesFiltersTh,
        refreshStatusTh,
        refreshPendingTh,
    })
)(SalesContainer);
